// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimplePaperPodcast-cls1___0ebd8f84d6e170ee43e{/*!*/}.SimplePaperPodcast-cls2___de73c1e84701c824fd5{padding:10px 16px;display:flex;align-items:center;grid-gap:6px;gap:6px;font-size:13px;color:#059669;font-weight:500}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SimplePaperPodcast-cls1___0ebd8f84d6e170ee43e",
	"cls2": "SimplePaperPodcast-cls2___de73c1e84701c824fd5 SimplePaperPodcast-cls1___0ebd8f84d6e170ee43e"
};
export default ___CSS_LOADER_EXPORT___;
